import BirthdayIcon from "assets/icons/BirthdayIcon";
import InfluencerIcon from "assets/icons/InfluencerIcon";
import LocationIcon from "assets/icons/LocationIcon";
import NichesIcon from "assets/icons/NichesIcon";
import { SocialAccountInsights } from "types/influencer"

const AudienceDetails: React.FC<{ socialAccountInsights: SocialAccountInsights }> = ({ socialAccountInsights }) => {

    if(Object.values(socialAccountInsights?.city ?? {}).length === 0 && 
        Object.values(socialAccountInsights?.gender ?? {}).length === 0 &&
        Object.values(socialAccountInsights?.age ?? {}).length === 0 &&
        Object.values(socialAccountInsights?.niche_likes ?? {}).length === 0
    ) return null;

    return (
        <div className='detail-card border-1'>
            <div className="detail-card-header">
                Audience Details
            </div>
            <div className="detail-card-body p-3">
                {
                    Object.values(socialAccountInsights.city ?? {}).length > 0 &&
                    <div className="d-flex">
                        <LocationIcon size={24} className='me-2' />
                        <div className="d-flex align-items-center flex-column w-100">
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <span className='data-title'>Audience City</span>
                                <span className="data-title-info">Last 30 days</span>
                            </div>
                            {
                                Object.entries(socialAccountInsights.city ?? {}).map(([key, value], i) => {
                                    return (
                                        <div key={i} className="d-flex align-items-center flex-column mt-4 w-100">
                                            <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                                                <span className="demographic-key">{key}</span>
                                                <span className="demographic-value">{value}%</span>
                                            </div>
                                            <div className="h-8px mx-3 w-100 bg-success-light rounded">
                                                <div className="bg-success rounded h-8px" role="progressbar" style={{ width: `${value}%` }} aria-valuenow={50} aria-valuemin={0} aria-valuemax={100}></div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            <div className="divider my-4"></div>
                            </div>
                    </div>
                }
                {
                    Object.values(socialAccountInsights.gender ?? {}).length > 0 &&
                    <div className="d-flex">
                        <InfluencerIcon size={24} className='me-2' />
                        <div className="d-flex align-items-center flex-column w-100">
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <span className='data-title'>Audience Gender</span>
                                <span className="data-title-info">Last 30 days</span>
                            </div>
                            {
                                Object.entries(socialAccountInsights.gender ?? {}).map(([key, value], i) => {
                                    return (
                                        <div key={i} className="d-flex align-items-center flex-column mt-4 w-100">
                                            <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                                                <span className="demographic-key">{key}</span>
                                                <span className="demographic-value">{value}%</span>
                                            </div>
                                            <div className="h-8px mx-3 w-100 bg-success-light rounded">
                                                <div className="bg-success rounded h-8px" role="progressbar" style={{ width: `${value}%` }} aria-valuenow={50} aria-valuemin={0} aria-valuemax={100}></div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            <div className="divider my-4"></div>
                        </div>

                    </div>
                }
                {
                    Object.values(socialAccountInsights.age ?? {}).length > 0 &&
                    <div className="d-flex">
                        <BirthdayIcon size={24} className='me-2' />
                        <div className="d-flex align-items-center flex-column w-100">
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <span className='data-title'>Audience Age</span>
                                <span className="data-title-info">Last 30 days</span>
                            </div>
                            {
                                Object.entries(socialAccountInsights.age ?? {}).map(([key, value], i) => {
                                    return (
                                        <div key={i} className="d-flex align-items-center flex-column mt-4 w-100">
                                            <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                                                <span className="demographic-key">{key}</span>
                                                <span className="demographic-value">{value}%</span>
                                            </div>
                                            <div className="h-8px mx-3 w-100 bg-success-light rounded">
                                                <div className="bg-success rounded h-8px" role="progressbar" style={{ width: `${value}%` }} aria-valuenow={50} aria-valuemin={0} aria-valuemax={100}></div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            <div className="divider my-4"></div>
                        </div>

                    </div>
                }
                {
                    Object.values(socialAccountInsights.niche_likes ?? {}).length > 0 &&
                    <div className="d-flex">
                        <NichesIcon size={24} className='me-2' />
                        <div className="d-flex align-items-center flex-column w-100">
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <span className='data-title'>Audience Interests</span>
                                <span className="data-title-info">Last 30 days</span>
                            </div>
                            {
                                Object.entries(socialAccountInsights.niche_likes ?? {}).map(([key, value], i) => {
                                    return (
                                        <div key={i} className="d-flex align-items-center flex-column mt-4 w-100">
                                            <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                                                <span className="demographic-key">{key}</span>
                                                <span className="demographic-value">{value}%</span>
                                            </div>
                                            <div className="h-8px mx-3 w-100 bg-success-light rounded">
                                                <div className="bg-success rounded h-8px" role="progressbar" style={{ width: `${value}%` }} aria-valuenow={50} aria-valuemin={0} aria-valuemax={100}></div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default AudienceDetails